import React, { useRef } from "react";
import { FiUploadCloud } from "react-icons/fi";
import { PulseLoader } from "react-spinners";
import { useAppContext } from "../../../context/AppContext";
import useAjoutProjectForm from "../../../hook/useAjoutProjectHookForm";
import MonBouton from "../../Utils/design-system/buttons/MonBouton";
import MonInput from "../../Utils/design-system/inputs/MonInput";
import InputWysiwyg from "../../Utils/InputWysiwyg";
import {
  formLabelImage,
  formProps,
  formPropsLinkAndObj,
} from "../../Utils/UtilsForm";

const initialFormState = {
  name: "",
  email: "",
  statut: "prospect",
  number: "",
  pays: "",
  titre: "",
  objectif: "",
  budget: "",
  image: null,
};

function AjoutProjectForm() {
  const {
    text,
    handleTextChange,
    errors,
    formRef,
    formState,
    handleChange,
    successMessage,
    errorMessage,
    handleSubmit,
    isLoadingProjectAdded,
  } = useAjoutProjectForm(initialFormState, formProps, formPropsLinkAndObj);
  const { countryOptions } = useAppContext();

  return (
    <form
      ref={formRef}
      className="flex flex-wrap justify-between"
      onSubmit={handleSubmit}
    >
      {successMessage && (
        <div className="w-full bg-green-100 border-x-4 mt-5 border-vr text-green-800 animate-bounce py-5 px-6 rounded mb-6 text-center">
          {successMessage}
        </div>
      )}

      {errorMessage && (
        <div className="w-full mt-4 border-b border-red animate-bounce bg-red/10 text-red py-5 px-6 rounded mb-6 text-center">
          {errorMessage}
        </div>
      )}

      {formProps.map((elem, i) => (
        <div className="w-[49%] mb-3 md:mb-0 max-md:w-full" key={i}>
          <MonInput
            label={elem.label}
            type={elem.type}
            id={elem.id}
            key={elem.id}
            value={formState[elem.id]}
            onChange={handleChange}
            options={elem.id === "pays" ? countryOptions : elem.options}
            placeholder={elem.placeholder}
            paddingB={
              "w-full bg-transparent font-bold ps-4 rounded-md outline-none border-gray-300 py-2"
            }
            position={"flex-col"}
            labelStyle={"w-full text-[16px] pb-3"}
            required={true}
            suffix={elem.suffix}
            padding={"py-2"}
            marginB={"w-full"}
          />
          {/* {errors[elem.id] && (
            <div className={`${elem.errorStyle} flex items-center`}>
              <span className="me-2">
                <FiUploadCloud />
              </span>
              {elem.errorMessage}
            </div>
          )} */}

          {errors[elem.id] && (
            <div className={`${elem.errorStyle} flex items-center`}>
              {" "}
              <span className="me-2">
                {" "}
                <FiUploadCloud />{" "}
              </span>{" "}
              {errors[elem.id]}{" "}
            </div>
          )}
        </div>
      ))}
      <div className="flex flex-wrap justify-between w-full">
        <div className="w-[49%] max-md:w-full">
          <InputWysiwyg
            text={formState.objectif}
            setText={(value) =>
              handleChange({ target: { id: "objectif", value } })
            }
            placeholder={"Décrire l'objectif du projet"}
            label={"Objectif du projet"}
            height={"80px"}
            width={"w-full"}
            required={true}
          />

          <InputWysiwyg
            text={text}
            setText={handleTextChange}
            placeholder={"Exprimer votre besoin, (au moins 50 caractères)"}
            label={"Description (au moins 50 caractères)"}
            height={"152px"}
            width={"w-full"}
            required={true}
          />
        </div>
        <div className="w-[49%] max-md:w-full h-full">
          <div className="w-full h-[90%] mb-3 md:mb-0">
            <MonInput
              label={
                formState?.image !== null
                  ? formLabelImage(
                      <img
                        src={URL.createObjectURL(formState.image)}
                        alt="preview"
                        className="!w-full h-full rounded-md"
                      />
                    )
                  : formLabelImage(
                      <div className="flex flex-col items-center gap-3 w-[95%]">
                        <div className="w-full py-12 flex flex-col justify-center items-center border border-dashed rounded-md font-inter gap-3 border-grys/80">
                          <FiUploadCloud className="size-12 text-graytertiary" />
                          <span className="text-graytertiary">
                            Télécharger ou glisser et déposer une image
                          </span>
                        </div>
                      </div>
                    )
              }
              type={"file"}
              id={"image"}
              onChange={handleChange}
              placeholder={""}
              paddingB={"md:w-[95%] py-3 flex items-center hidden"}
              labelStyle={"text-md ms-1 mb-3 w-full"}
            />
            {errors["image"] && (
              <div className="text-red-500">{errors["image"]}</div>
            )}
          </div>
        </div>
      </div>
      <div className="flex justify-center py-6 w-[98%]">
        <MonBouton
          type={"submit"}
          couleurFond={"bg-orange text-white"}
          bordure={
            "px-2 py-2 rounded-full justify-center gap-1 text-sm w-1/6 max-md:w-max max-md:px-12"
          }
          iconRight={""}
          icone={""}
        >
          {isLoadingProjectAdded ? (
            <>
              Envoi en cours <PulseLoader size={"5px"} color="#fff" />
            </>
          ) : (
            "Envoyer"
          )}
        </MonBouton>
      </div>
    </form>
  );
}

export default AjoutProjectForm;
